import styled from 'styled-components'
import { ProductName } from '@/features/shop/components/ProductDetailCommon/ProductName'
import { Column, Row } from '@shipt/design-system-layouts'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { screenSizes } from '@shipt/design-system-themes'
import { useMediaQuery } from '@/features/shared/hooks/useMediaQuery'
import { type ReactNode } from 'react'
import { GridLayoutContainer } from '@/features/shared/styles/layout'

type Props = {
  product: {
    oos: boolean
    image: { original_size_url?: string | null; url: string }
    name: string
  }
  isVisible: boolean
  productPrice: ReactNode
  children: ReactNode
}

export const ProductDetailDockedATC = ({ product, isVisible, children, productPrice }: Props) => {
  const { screenSm } = useMediaQuery()
  if (product.oos) return
  if (screenSm && isVisible) {
    return <MobileButtonWrapper>{children}</MobileButtonWrapper>
  }
  return (
    <AtcContainer isVisible={isVisible}>
      <GridLayoutContainer>
        <Row justify="space-between" align="center" spacing="sm">
          <Row>
            <ImageWrapper
              src={product.image.original_size_url ?? product.image.url}
              alt={product.name}
              height={64}
              width={64}
            />
            <Column>
              <ProductName name={product.name} />
              {productPrice}
            </Column>
          </Row>
          <ButtonWrapper>{children}</ButtonWrapper>
        </Row>
      </GridLayoutContainer>
    </AtcContainer>
  )
}

const AtcContainer = styled.div<{ isVisible: boolean }>`
  transform: ${({ isVisible }) => (isVisible ? 'translateY(0)' : 'translateY(-100%)')};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  transition:
    transform 0.5s ease-in-out,
    visibility 0.3s ease-in-out;
  pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};

  @media ${screenSizes.max_mobile} {
    display: none;
  }

  @media ${screenSizes.tablet} {
    min-height: 80px;
    background-color: white;
    border-bottom: 1px solid ${({ theme }) => theme.gray300};
    padding: 18px 0;
  }

  @media ${screenSizes.only_tablet} {
    padding: 18px 50px;
  }
`

const ImageWrapper = styled(Image)`
  min-width: 56px;
  min-height: 56px;
  margin-right: 1rem;
  object-fit: contain;
`

const ButtonWrapper = styled.div`
  width: 258px;
`

const MobileButtonWrapper = styled.div`
  pointer-events: auto;
  background-color: white;
  border-top: 1px solid ${({ theme }) => theme.gray300};
  padding: 16px;
`
